import { useEffect, useMemo, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { ErrorMessage, Form, Formik } from 'formik'
import Button from '../../../components/button/Button'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ROUTES_PATH } from '../../../utility/constants'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { exportStudentReport, generateDropdownOptions, convertTZToDate } from '../../../utility/genricFunction'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './feesCollectionDue.scss'
import { getBatchFromBranch, getFeesDueDetailsReport, getStudentDetailsReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

function FeesCollectionDueReport() {

    const dispatch = useDispatch();
    const reportData = useSelector((store) => store.reports.feesDetailsReportData);
    const { loading, pageDropDownLoading } = useSelector((store) => store.reports);

    const batches = useSelector((store) => store.reports.batches);
    const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches]);

    const branches = useSelector((state) => state?.branch?.branchTableData);
    const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches]);

    const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
    const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

    const [branch, setBranch] = useState("");
    const [batch, setBatch] = useState("");
    const [isTableOpen, setIsTableOpen] = useState(false);

    const [initialValues] = useState({
        branch: userRole == "branch" ? branchId : '',
        batch: ''
    })

    useEffect(() => {
        // dispatch(getBranch('active'));

        if (userRole == "branch") {
            dispatch(getBatchFromBranch(branchId))
        }
    }, []);

    const validationSchema = Yup.object().shape({
        branch: Yup.string()
            .required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
        batch: Yup.string()
            .required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    });

    function handleFormSubmit(values) {
        setBranch(values.branch);
        setBatch(values.batch);
        setIsTableOpen(true);

        const data = {
            branch: values.branch,
            batch: values.batch,
            month: values.month,
            year: values.year
        };

        dispatch(getFeesDueDetailsReport(data));
    }

    const handleBranchChange = (value, setFieldValue) => {
        setFieldValue("branch", value);
        dispatch(getBatchFromBranch(value));
    }

    const breadCrumbsArr = [
        {
            title: 'Fees Details',
            link: null,
        },
        {
            title: 'Dashboard',
            link: ROUTES_PATH.DASHBOARD,
        },
        {
            title: 'Fees Details',
            link: ROUTES_PATH.FEES_COLLECTION_DUE_REPORT,
        },
    ];

    const printRef = useRef()

    const handleDownloadPfd = useReactToPrint({
        content: () => printRef.current,
    });


    const dateBody = (reporData) => {
        const representative = reporData?.enrollmentDate && convertTZToDate(reporData?.enrollmentDate)
        return (
            <div className='flex align-items-center gap-2'>
                <span>{representative}</span>
            </div>
        );
    }

    const birthDateBody = (reporData) => {
        const representative = reporData?.birthDate && convertTZToDate(reporData?.birthDate)
        return (
            <div className='flex align-items-center gap-2'>
                <span>{representative}</span>
            </div>
        );
    }

    const columns = [
        {
            field: 'no',
            header: "#",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '3rem' },
        },
        {
            field: 'studentCode',
            header: "Code",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'studentName',
            header: "Student Name",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'enrollmentDate',
            header: "Reg. Date",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '6rem' },
            body: dateBody
        },
        {
            field: 'birthDate',
            header: "Birth Date",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '6rem' },
            body: birthDateBody
        },
        {
            field: 'parentPhone',
            header: "Mobile No.",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'studentPhone',
            header: "Alt No.",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'email',
            header: "Email ID",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'totalFees',
            header: "Total Fees",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
        {
            field: 'Total Fees',
            header: "Paid",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
        {
            field: 'pendingAmount',
            header: "Pending",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
    ];

    const monthOption = [
        { label: "January", value: 1 },
        { label: "February", value: 2 },
        { label: "March", value: 3 },
        { label: "April", value: 4 },
        { label: "May", value: 5 },
        { label: "June", value: 6 },
        { label: "July", value: 7 },
        { label: "August", value: 8 },
        { label: "September", value: 9 },
        { label: "October", value: 10 },
        { label: "November", value: 11 },
        { label: "December", value: 12 }
    ];

    const currentYear = new Date().getFullYear();
    const yearOptions = [
        { label: currentYear - 3, value: currentYear - 3 },
        { label: currentYear - 2, value: currentYear - 2 },
        { label: currentYear - 1, value: currentYear - 1 },
        { label: currentYear, value: currentYear }
    ];

    return (
        <>
            {loading && <Loader loading={loading} />}
            {<Loader loading={loading} /> && <div className='studentDetailsReport-wrapper'>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        handleFormSubmit(values);
                    }}
                    enableReinitialize
                >
                    {({ values, handleChange, handleSubmit, setFieldValue }) => (
                        <Form>
                            <div className='studentDetailsReport-header'>
                                <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                            </div>

                            <div className='studentDetailsReport'>
                                <div className='studentDetailsReport-input-fields'>
                                    <div className='studentDetailsReport-input'>
                                        <label htmlFor=''>
                                            Branch<span className='required-symbol'>*</span>
                                        </label>
                                        <PageDropdown
                                            loading={pageDropDownLoading}
                                            options={branchOption}
                                            selectedValue={values.branch}
                                            className={'studentDetailsReport-dropdown'}
                                            onChange={(e) => handleBranchChange(e.target.value, setFieldValue)}
                                            name={'branch'}
                                            placeholder={'Select Branch'}
                                            disabled={userRole == "branch"}
                                        />
                                        <ErrorMessage name='branch' component='div' className='error-msg' />
                                    </div>

                                    <div className='studentDetailsReport-input'>
                                        <label htmlFor=''>
                                            Batch<span className='required-symbol'>*</span>
                                        </label>
                                        <PageDropdown
                                            loading={pageDropDownLoading}
                                            options={batchOptions}
                                            selectedValue={values.batch}
                                            className={'studentDetailsReport-dropdown'}
                                            onChange={handleChange}
                                            name={'batch'}
                                            placeholder={'Select Batch'}
                                        />
                                        <ErrorMessage name='batch' component='div' className='error-msg' />
                                    </div>

                                    <div className='studentDetailsReport-input'>
                                        <label htmlFor=''>
                                            Month<span className='required-symbol'>*</span>
                                        </label>
                                        <PageDropdown
                                            loading={pageDropDownLoading}
                                            options={monthOption}
                                            selectedValue={values.month}
                                            className={'studentDetailsReport-dropdown'}
                                            onChange={handleChange}
                                            name={'month'}
                                            placeholder={'Select Month'}
                                        />
                                        <ErrorMessage name='batch' component='div' className='error-msg' />
                                    </div>

                                    <div className='studentDetailsReport-input'>
                                        <label htmlFor=''>
                                            Year<span className='required-symbol'>*</span>
                                        </label>
                                        <PageDropdown
                                            loading={pageDropDownLoading}
                                            options={yearOptions}
                                            selectedValue={values.year}
                                            className={'studentDetailsReport-dropdown'}
                                            onChange={handleChange}
                                            name={'year'}
                                            placeholder={'Select Year'}
                                        />
                                        <ErrorMessage name='batch' component='div' className='error-msg' />
                                    </div>

                                </div>
                                    <div className='report-submit-div'>
                                        <Button customClassName={'save-btn'} onClick={handleSubmit}>
                                            Submit
                                        </Button>
                                    </div>
                            </div>
                        </Form>
                    )}
                </Formik>

                {isTableOpen && (
                    <div className='studentDetailsReport-table'>
                        <div className='export-option-wrapper'>

                            <div className='pdf-excel-export'>
                                {/* <Button
                                text={'Export'}
                                type={'button'}
                                onClick={() =>
                                    exportStudentReport(reportData, 'Student Details Report', 'StudentDetailsReport.xlsx')
                                }
                                disabled={reportData?.length > 0 ? false : true}
                            >
                                <SimCardDownloadIcon />
                            </Button> */}

                                <Button text={'Export'}
                                    type={'button'}
                                    onClick={handleDownloadPfd}
                                    disabled={reportData?.length > 0 ? false : true}>
                                    <PrintIcon />
                                </Button>
                            </div>
                        </div>

                        <div className='printable-component' ref={printRef}>
                            <ReportDataTable
                                columns={columns}
                                value={reportData}
                                loading={loading}
                            />
                        </div>


                    </div>
                )}
            </div>}
        </>
    );
}

export default FeesCollectionDueReport;
